import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahFreeAdaptedEditor = () => {
  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    // SPEC 1
    Spec1ValueEn: "", Spec1ValueAr: "", Spec1ValueKu: "",
    Spec1LabelEn: "", Spec1LabelAr: "", Spec1LabelKu: "",

    // SPEC 2
    Spec2ValueEn: "", Spec2ValueAr: "", Spec2ValueKu: "",
    Spec2LabelEn: "", Spec2LabelAr: "", Spec2LabelKu: "",

    // SPEC 3
    Spec3ValueEn: "", Spec3ValueAr: "", Spec3ValueKu: "",
    Spec3LabelEn: "", Spec3LabelAr: "", Spec3LabelKu: "",

    // SPEC 4
    Spec4ValueEn: "", Spec4ValueAr: "", Spec4ValueKu: "",
    Spec4LabelEn: "", Spec4LabelAr: "", Spec4LabelKu: "",

    // ROW 1
    Row1TitleEn: "", Row1TitleAr: "", Row1TitleKu: "",
    Row1DescEn: "", Row1DescAr: "", Row1DescKu: "",

    // ROW 2
    Row2TitleEn: "", Row2TitleAr: "", Row2TitleKu: "",
    Row2DescEn: "", Row2DescAr: "", Row2DescKu: "",
  });

  const [image, setImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${API_BASE}${u}`);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ================================
  // LOAD ALL 3 LANGUAGES
  // ================================
  useEffect(() => {
    const loadAll = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VFAdaptedSection?lang=en`),
          axios.get(`${API_BASE}/api/VFAdaptedSection?lang=ar`),
          axios.get(`${API_BASE}/api/VFAdaptedSection?lang=ku`),
        ]);

        setForm({
          // SPEC 1
          Spec1ValueEn: en.data.specs[0].value,
          Spec1LabelEn: en.data.specs[0].label,
          Spec1ValueAr: ar.data.specs[0].value,
          Spec1LabelAr: ar.data.specs[0].label,
          Spec1ValueKu: ku.data.specs[0].value,
          Spec1LabelKu: ku.data.specs[0].label,

          // SPEC 2
          Spec2ValueEn: en.data.specs[1].value,
          Spec2LabelEn: en.data.specs[1].label,
          Spec2ValueAr: ar.data.specs[1].value,
          Spec2LabelAr: ar.data.specs[1].label,
          Spec2ValueKu: ku.data.specs[1].value,
          Spec2LabelKu: ku.data.specs[1].label,

          // SPEC 3
          Spec3ValueEn: en.data.specs[2].value,
          Spec3LabelEn: en.data.specs[2].label,
          Spec3ValueAr: ar.data.specs[2].value,
          Spec3LabelAr: ar.data.specs[2].label,
          Spec3ValueKu: ku.data.specs[2].value,
          Spec3LabelKu: ku.data.specs[2].label,

          // SPEC 4
          Spec4ValueEn: en.data.specs[3].value,
          Spec4LabelEn: en.data.specs[3].label,
          Spec4ValueAr: ar.data.specs[3].value,
          Spec4LabelAr: ar.data.specs[3].label,
          Spec4ValueKu: ku.data.specs[3].value,
          Spec4LabelKu: ku.data.specs[3].label,

          // ROW 1
          Row1TitleEn: en.data.row1Title,
          Row1DescEn: en.data.row1Desc,
          Row1TitleAr: ar.data.row1Title,
          Row1DescAr: ar.data.row1Desc,
          Row1TitleKu: ku.data.row1Title,
          Row1DescKu: ku.data.row1Desc,

          // ROW 2
          Row2TitleEn: en.data.row2Title,
          Row2DescEn: en.data.row2Desc,
          Row2TitleAr: ar.data.row2Title,
          Row2DescAr: ar.data.row2Desc,
          Row2TitleKu: ku.data.row2Title,
          Row2DescKu: ku.data.row2Desc,
        });

        setImage(en.data.bigImage);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    };

    loadAll();
  }, []);

  // ================================
  // SAVE TEXTS
  // ================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VFAdaptedSection/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Adapted section texts updated!");
    } catch (err) {
      console.error(err);
      alert("Save failed.");
    }
  };

  // ================================
  // UPLOAD BIG IMAGE
  // ================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select an image!");

    const fd = new FormData();
    fd.append("BigImage", uploadFile);

    const token = localStorage.getItem("token");

    try {
      await axios.post(`${API_BASE}/api/VFAdaptedSection/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah FREE – Adapted Section Editor</h2>

      <div className="row">
        {LANGS.map((lang) => (
          <div className="col-lg-4 col-md-6 mb-4" key={lang}>
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang} Version</h5>

                {/* ===================== SPEC 1 ===================== */}
                <h6 className="mt-3 text-secondary">Spec 1</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Value"
                  name={`Spec1Value${lang}`}
                  value={form[`Spec1Value${lang}`]}
                  onChange={handleChange}
                />
                <input
                  className="form-control mb-3"
                  placeholder="Label"
                  name={`Spec1Label${lang}`}
                  value={form[`Spec1Label${lang}`]}
                  onChange={handleChange}
                />

                {/* ===================== SPEC 2 ===================== */}
                <h6 className="text-secondary">Spec 2</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Value"
                  name={`Spec2Value${lang}`}
                  value={form[`Spec2Value${lang}`]}
                  onChange={handleChange}
                />
                <input
                  className="form-control mb-3"
                  placeholder="Label"
                  name={`Spec2Label${lang}`}
                  value={form[`Spec2Label${lang}`]}
                  onChange={handleChange}
                />

                {/* ===================== SPEC 3 ===================== */}
                <h6 className="text-secondary">Spec 3</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Value"
                  name={`Spec3Value${lang}`}
                  value={form[`Spec3Value${lang}`]}
                  onChange={handleChange}
                />
                <input
                  className="form-control mb-3"
                  placeholder="Label"
                  name={`Spec3Label${lang}`}
                  value={form[`Spec3Label${lang}`]}
                  onChange={handleChange}
                />

                {/* ===================== SPEC 4 ===================== */}
                <h6 className="text-secondary">Spec 4</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Value"
                  name={`Spec4Value${lang}`}
                  value={form[`Spec4Value${lang}`]}
                  onChange={handleChange}
                />
                <input
                  className="form-control mb-3"
                  placeholder="Label"
                  name={`Spec4Label${lang}`}
                  value={form[`Spec4Label${lang}`]}
                  onChange={handleChange}
                />

                {/* ===================== ROW 1 ===================== */}
                <h6 className="mt-3 text-secondary">Row 1</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Row 1 Title"
                  name={`Row1Title${lang}`}
                  value={form[`Row1Title${lang}`]}
                  onChange={handleChange}
                />
                <textarea
                  rows={3}
                  className="form-control mb-3"
                  placeholder="Row 1 Description"
                  name={`Row1Desc${lang}`}
                  value={form[`Row1Desc${lang}`]}
                  onChange={handleChange}
                />

                {/* ===================== ROW 2 ===================== */}
                <h6 className="text-secondary">Row 2</h6>
                <input
                  className="form-control mb-2"
                  placeholder="Row 2 Title"
                  name={`Row2Title${lang}`}
                  value={form[`Row2Title${lang}`]}
                  onChange={handleChange}
                />
                <textarea
                  rows={3}
                  className="form-control"
                  placeholder="Row 2 Description"
                  name={`Row2Desc${lang}`}
                  value={form[`Row2Desc${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* IMAGE BLOCK */}
      <h4 className="mb-3">Big Image</h4>
      <div className="card shadow-sm mb-4">
        <div className="card-body">
          {image ? (
            <img
              src={resolveUrl(image)}
              alt=""
              className="w-100 rounded mb-3"
              style={{ maxHeight: "260px", objectFit: "cover" }}
            />
          ) : (
            <p>No image uploaded.</p>
          )}

          <button className="btn btn-primary" onClick={() => setShowModal(true)}>
            Upload / Replace
          </button>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Big Image</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default VoyahFreeAdaptedEditor;
